import React, { useEffect, useState, lazy, Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Spin } from "antd";
import { ProtectedRoute } from "./ProtectedRoute";
import { AuthProvider } from "./AuthProvider";
import { usePermissions } from '../PermissionsContext';
import { routesWithComp, routesWithAdminComp } from './routeList';
import { useLocation } from 'react-router-dom';
import { flatMap } from "lodash";

const Dashboard = lazy(() => import("../Dashboard"));
const UserDashboard = lazy(() => import("../Dashboard/userDashboard"));
const LoginView = lazy(() => import("../Login/pages"));
const PageNotFound = lazy(() => import("./PageNotFound"));
const BillAdjustment = lazy(() => import("../BillAdjustment/pages"));
const InvoiceLayout = lazy(() => import("../InvoiceLayout/pages"));
const RegisterBrokerNotifications = lazy(() => import("../Notifications/RegisterBrokerNotifications/pages"));

const PrivacyPolicy = lazy(() => import("./PrivacyPolicy"));

const DashboardComponent = () => {
  const superUser = useSelector((state) => state.auth.superUser);
  const auth = useSelector((state) => state.auth);
  if(superUser) {
    return <div/>;
  } else if(auth.customer.User_Id === auth.user.id) {
    return <Dashboard />;
  } else {
    return <UserDashboard />;
  }
  // const superUser = useSelector((state) => state.auth?.superUser);
  // return superUser ? <div/> : <Dashboard/>;
}

export const AppRoutes = () => {
  const [routes, setRoutes] = useState(routesWithComp);
  const superUser = useSelector((state) => state.auth?.superUser);
  const { permissions } = usePermissions();
  const location = useLocation();

  useEffect(() => {
    if (permissions?.length) {
      let menus = permissions.filter((val) => (val.Visible)).map((val) => ([(val?.Module?.Name || ''), `${(val?.Module?.Name || '')}-alter`]));
      menus = flatMap(menus);
      const filterRoutes = routesWithComp.filter((route) => menus.includes(route.key));
      setRoutes(filterRoutes);
    } else {
      setRoutes([]);
    }
  }, [permissions]);

  // Check if current path is privacy policy
  if (location.pathname === '/privacy-policy') {
    return (
      <Routes>
        <Route 
          path="/privacy-policy" 
          loader={<Spin spinning={true} />} 
          element={
            <Suspense fallback={<Spin spinning={true} />}>
              <PrivacyPolicy />
            </Suspense>
          } 
        />
        <Route path="*" element={<Navigate to="/404" replace />} />
        <Route path="/404" element={<PageNotFound />} />
      </Routes>
    );
  }

  return (
    <AuthProvider>
      <Routes>
        <Route
          path="/"
          loader={<Spin spinning={true} />}
          element={
            <Suspense fallback={<Spin spinning={true} />}>
              <ProtectedRoute>
                <div>Dashboard</div>
              </ProtectedRoute>
            </Suspense>
          }
        />
        <Route
          path="/login"
          loader={<Spin spinning={true} />}
          element={
            <Suspense fallback={<Spin spinning={true} />}>
              <ProtectedRoute>
                <LoginView />
              </ProtectedRoute>
            </Suspense>
          }
        />
        <Route
          path="/dashboard"
          loader={<Spin spinning={true} />}
          element={
            <Suspense fallback={<Spin spinning={true} />}>
              <ProtectedRoute>
                <DashboardComponent />
              </ProtectedRoute>
            </Suspense>
          }
        />
        <Route
          path="/bill-adjustment"
          loader={<Spin spinning={true} />}
          element={
            <Suspense fallback={<Spin spinning={true} />}>
              <ProtectedRoute>
                <BillAdjustment />
              </ProtectedRoute>
            </Suspense>
          }
        />
        <Route
          path="/invoice"
          loader={<Spin spinning={true} />}
          element={
            <Suspense fallback={<Spin spinning={true} />}>
              <ProtectedRoute>
                <InvoiceLayout />
              </ProtectedRoute>
            </Suspense>
          }
        />
        <Route
          path="/notifications/register-broker"
          loader={<Spin spinning={true} />}
          element={
            <Suspense fallback={<Spin spinning={true} />}>
              <ProtectedRoute>
                <RegisterBrokerNotifications/>
              </ProtectedRoute>
            </Suspense>
          }
        />

        {(superUser?.id ? routesWithAdminComp : routes).map((route, i) => (
          <Route
            key={i}
            path={route.path}
            loader={<Spin spinning={true} />}
            element={(
              <Suspense fallback={<Spin spinning={true} />}>
                <ProtectedRoute>
                  {route.component}
                </ProtectedRoute>
              </Suspense>
            )}
          />
        ))}
        
        <Route path="*" element={<Navigate to="/404" replace />} />
        <Route path="/404" element={<PageNotFound />} />
      </Routes>
    </AuthProvider>
  );
};
